// import { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { fetchState, createRegion } from "../../../api/locationApi";
// import { toast } from "react-toastify";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   MenuItem,
//   Select,
//   TextField,
//   Typography,
//   InputLabel,
//   FormControl,
//   Paper,
// } from "@mui/material";

// export default function RegionForm() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state?.region || null;

//   const [stateList, setStateList] = useState([]);
//   const [form, setForm] = useState({
//     region_state: "",
//     region_name: "",
//   });
//   const [loading, setLoading] = useState(false);

//   const isEditMode = !!editData;

//   // Load states on mount
//   useEffect(() => {
//     async function loadStates() {
//       try {
//         const res = await fetchState();
//         setStateList(res || []);
//       } catch (err) {
//         console.error("Error loading states:", err);
//         toast.error("Failed to load states");
//       }
//     }
//     loadStates();
//   }, []);

//   // Prefill form only after state list is loaded
//   useEffect(() => {
//     if (isEditMode && stateList.length > 0) {
//       // Try to find matching state in the list
//       const matchedState = stateList.find(
//         (s) =>
//           s.description?.toLowerCase() === editData.state?.toLowerCase() ||
//           s.description?.toLowerCase() === editData.region_state?.toLowerCase()
//       );

//       setForm({
//         region_state: matchedState
//           ? matchedState.description
//           : editData.state || editData.region_state || "",
//         region_name: editData.region_name || editData.name || "",
//         tr_id: editData.tr_id || "",
//       });
//     }
//   }, [editData, stateList, isEditMode]);

//   // Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   // Handle submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.region_state || !form.region_name) {
//       toast.warning("Please fill all fields");
//       return;
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         region_state: form.region_state,
//         region_name: form.region_name,
//       };

//       if (isEditMode && form.tr_id) {
//         payload.tr_id = form.tr_id;
//       }

//       const res = await createRegion(payload);
//       console.log("Region API Response:", res);

//       if (res?.status === "success" || res?.success) {
//         toast.success(
//           isEditMode
//             ? "Region updated successfully"
//             : "Region created successfully"
//         );
//         navigate("/region-master");
//       } else {
//         toast.error(res?.message || "Operation failed");
//       }
//     } catch (err) {
//       console.error("Error creating/updating region:", err);
//       toast.error("Error processing request");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5" gutterBottom>
//         {isEditMode ? "Edit Region" : "Add New Region"}
//       </Typography>

//       <Paper
//         sx={{
//           p: 3,
//           borderRadius: 2,
//           boxShadow: 2,
//           backgroundColor: "#fafafa",
//           maxWidth: 500,
//         }}
//       >
//         <form onSubmit={handleSubmit}>
//           {/* State Dropdown */}
//           <FormControl fullWidth sx={{ mb: 3 }}>
//             <InputLabel id="state-label">Select State</InputLabel>
//             <Select
//               labelId="state-label"
//               name="region_state"
//               value={form.region_state}
//               onChange={handleChange}
//               label="Select State"
//             >
//               <MenuItem value="">
//                 <em>-- Select State --</em>
//               </MenuItem>
//               {stateList.map((s) => (
//                 <MenuItem key={s.code} value={s.description}>
//                   {s.description}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {/* Region Name */}
//           <TextField
//             fullWidth
//             label="Region Name"
//             name="region_name"
//             value={form.region_name}
//             onChange={handleChange}
//             placeholder="Enter Region Name"
//             variant="outlined"
//             sx={{ mb: 3 }}
//           />

//           {/* Buttons */}
//           <Box sx={{ display: "flex", gap: 2 }}>
//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               disabled={loading}
//               startIcon={loading && <CircularProgress size={18} />}
//             >
//               {loading
//                 ? "Saving..."
//                 : isEditMode
//                 ? "Update"
//                 : "Submit"}
//             </Button>

//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={() => navigate("/region-master")}
//             >
//               Cancel
//             </Button>
//           </Box>
//         </form>
//       </Paper>
//     </Box>
//   );
// }





import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchState, createRegion } from "../../../api/locationApi";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputLabel,
  FormControl,
  Paper,
} from "@mui/material";

export default function RegionForm() {
  const navigate = useNavigate();
  const [stateList, setStateList] = useState([]);
  const [form, setForm] = useState({
    region_state: "",
    region_name: "",
  });
  const [loading, setLoading] = useState(false);

  // Load states
  useEffect(() => {
    async function loadStates() {
      try {
        const res = await fetchState();
        setStateList(res || []);
      } catch (err) {
        console.error("Error loading states:", err);
        toast.error("Failed to load states");
      }
    }
    loadStates();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.region_state || !form.region_name) {
      toast.warning("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        region_state: form.region_state,
        region_name: form.region_name,
      };

      const res = await createRegion(payload);
      console.log("Region API Response:", res);

      if (res?.status === "success" || res?.success) {
        toast.success("Region created successfully");
        navigate("/region-master");
      } else {
        toast.error(res?.message || "Failed to create region");
      }
    } catch (err) {
      console.error("Error creating region:", err);
      toast.error("Error processing request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Add New Region
      </Typography>

      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: "#fafafa",
          maxWidth: 500,
        }}
      >
        <form onSubmit={handleSubmit}>
          {/* State Dropdown */}
          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel id="state-label">Select State</InputLabel>
            <Select
              labelId="state-label"
              name="region_state"
              value={form.region_state}
              onChange={handleChange}
              label="Select State"
            >
              <MenuItem value="">
                <em>-- Select State --</em>
              </MenuItem>
              {stateList.map((s) => (
                <MenuItem key={s.code} value={s.description}>
                  {s.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Region Name */}
          <TextField
            fullWidth
            label="Region Name"
            name="region_name"
            value={form.region_name}
            onChange={handleChange}
            placeholder="Enter Region Name"
            variant="outlined"
            sx={{ mb: 3 }}
          />

          {/* Buttons */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : "Submit"}
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate("/region-master")}
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}
